export interface LeadReferrerString {
  http_referer?: string;
  request_uri?: string;
}

export const DefaultLeadReferrerString : LeadReferrerString = {
  http_referer: '',
  request_uri: '',
}
